import Splide from "@splidejs/splide";
import "@splidejs/splide/dist/css/splide.min.css";
import gsap from "gsap";
import { disableBodyScroll, enableBodyScroll } from "../utils";

document.addEventListener("DOMContentLoaded", () => {
  const modal = document.querySelector(".sliderModal");
  const openModalBtns = document.querySelectorAll(
    ".business-space-modal__trigger"
  );
  const closeBtn = modal.querySelector(".modal__close");
  const customPrev = modal.querySelector(".splide__arrow--prev");
  const customNext = modal.querySelector(".splide__arrow--next");
  const customPagination = modal.querySelector(".splide__pagination");

  let splide = null;
  let prevHandler = null;
  let nextHandler = null;

  const clearCustomPagination = () => {
    if (customPagination) customPagination.innerHTML = "";
  };

  const initSplide = () => {
    splide = new Splide(modal.querySelector(".splide"), {
      type: "loop",
      focus: "center",
      padding: { left: "25%", right: "25%" },
      gap: "2vw",
      perPage: 1,
      pagination: false,
      autoplay: true,
      interval: 3000,
      speed: 1000,
      breakpoints: {
        1023: { padding: "20vw" },
      },
      arrows: false,
    });

    // Arrow events
    prevHandler = () => splide.go("<");
    nextHandler = () => splide.go(">");

    splide.on("mounted", () => {
      customPrev.addEventListener("click", prevHandler);
      customNext.addEventListener("click", nextHandler);

      // Custom pagination
      const numSlides = splide.length;
      for (let i = 0; i < numSlides; i++) {
        const bullet = document.createElement("li");
        bullet.className = "custom__pagination-bullet";
        bullet.textContent = "●";
        if (i === splide.index) bullet.classList.add("is-active");
        bullet.addEventListener("click", () => splide.go(i));
        customPagination.appendChild(bullet);
      }
    });

    // Pagination active state
    splide.on("move", (newIndex) => {
      const bullets = customPagination.querySelectorAll(
        ".custom__pagination-bullet"
      );
      bullets.forEach((b) => b.classList.remove("is-active"));
      if (bullets[newIndex]) bullets[newIndex].classList.add("is-active");
    });

    // Visible slide toggle
    splide.on("mounted move", () => {
      modal.querySelectorAll(".slide__item").forEach((slide) => {
        slide.classList.remove("is-visible");
      });
      const active = modal.querySelector(".splide__slide.is-active");
      if (active) active.classList.add("is-visible");
    });

    splide.mount();
  };

  const destroySplide = () => {
    if (splide) {
      splide.destroy(true);
      splide = null;
    }
    if (customPrev && prevHandler) {
      customPrev.removeEventListener("click", prevHandler);
    }
    if (customNext && nextHandler) {
      customNext.removeEventListener("click", nextHandler);
    }
    clearCustomPagination();
  };

  const openModal = () => {
    disableBodyScroll();
    gsap.set(modal, { autoAlpha: 0, display: "flex" });
    gsap.to(modal, {
      autoAlpha: 1,
      duration: 0.5,
      ease: "power2.out",
      onStart: () => {
        modal.classList.add("is-open");
      },
    });
    initSplide();
  };

  const closeModal = () => {
    gsap.to(modal, {
      autoAlpha: 0,
      duration: 0.4,
      ease: "power2.inOut",
      onComplete: () => {
        modal.style.display = "none";
        modal.classList.remove("is-open");
        enableBodyScroll();
        destroySplide();
      },
    });
  };

  // Bind open modal buttons
  openModalBtns.forEach((btn) => {
    btn.addEventListener("click", openModal);
  });

  // Close modal events
  closeBtn.addEventListener("click", closeModal);
  window.addEventListener("click", (e) => {
    if (e.target === modal) closeModal();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("is-open")) {
      closeModal();
    }
  });
});
